export default __webpack_public_path__ + "static/media/step-2-en.ea17dfe0.png";